module.exports = __webpack_public_path__ + "static/media/rightArrowTennis.afcc4fa0.svg";